// extracted by css-extract-rspack-plugin
export default {"container":"_8159c2bc"};